import { ConfigurationParameters } from '@cdab/opus-api-client'
import { getEnvironmentVariable } from './environment'

export const configParams: ConfigurationParameters = {
  basePath: getEnvironmentVariable('API_URL'),
}
